<div class="wrapper" [class.enabled]="permissionEdit.enabled && !skip" [ngClass]="style">
  @if (!notViewable || skip) {
  <ng-content></ng-content>
  } @else {
  <span [matTooltip]="'NO_PERMISSION_TO' | translate: { name: missingPermissionNames }">
    @if (customFallback) {
    <ng-content select="fallback-content"></ng-content>
    } @else if (showFallback) {
    <b>*****</b>
    }
  </span>
  }
  <div
    class="overlay"
    (click)="$event.stopPropagation(); edit()"
    [matTooltip]="'PERMISSION_EDIT_TOOLTIP' | translate: { name: permissionName }"
  ></div>
</div>
